module.exports = __webpack_public_path__ + "img/clock-3.b081c002.svg";